<script>
    export let icon;
    export let size = 16;
    export let color = 'currentColor';
    export let strokeWidth = 1;
    export let cssClass = '';
</script>

<span class="svg-icon { cssClass }">
{#if icon === 'check'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
{:else if icon === 'check-circle'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
{:else if icon === 'alert-circle'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
{/if}
</span>

<style>
    .svg-icon {
        line-height: 1;
    }
</style>